<template>
    <div  role="tab" class="accordion-item">
        <b-collapse :id="'accordion-' + i" class="order-item-table" accordion="my-accordion" role="tabpanel">
            <div class="order-item-table__header d-none d-lg-grid">
                <div>Фото</div>
                <div>Название</div>
                <div>Кол-во</div>
                <div>Цена</div>
                <!--                <div>Срок аренды</div>-->

                <div>Скидка</div>
                <div>Итого скидка</div>
                <div>Цена со скидкой</div>
            </div>

            <div v-for="order in item.items" class="order-item-table__item">
                <div class="image mobile_item">
                    <!--<span class="d-inline-block d-lg-none">Фото</span> -->
                    <img :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + order.code + '-f64'" alt="">
                </div>
                <div class="pr-lg-2 mobile_item">
                    <!--<span class="d-inline-block d-lg-none">Название</span> -->
                    <div class="pr-3 pl-3 pl-sm-0">{{order.name}}</div>
                </div>
                <div class="mobile_item">
                    <!--<span class="d-inline-block d-lg-none">Кол-во</span>-->
                    {{order.count}}
                </div>
                <div class="mobile_item">
                    <!--<span class="d-inline-block d-lg-none">Цена</span>-->
                    {{order.common_price}} RUB
                </div>

                <!--                <div class="mobile_item">-->
                <!--                    <span class="d-inline-block d-lg-none">Срок аренды</span>-->
                <!--                    с {{getDateTime(item.booked_from)}}<br> по {{getDateTime(item.booked_until)}}-->
                <!--                </div>-->

                <div class="mobile_item d-none d-lg-block">
                    <span class="d-inline-block d-lg-none">Скидка</span>
                    {{order.discount}} %
                </div>
                <div class="mobile_item d-none d-lg-block">
                    <span class="d-inline-block d-lg-none">Итого скидка</span>
                    {{order.common_discount}} RUB
                </div>
                <div class="mobile_item d-none d-lg-block">
                    <span class="d-inline-block d-lg-none">Цена со скидкой</span>
                    {{order.finally_price}} RUB
                </div>
            </div>

            <div class="additional-information">

                <div v-if="item.services && item.services.length > 0">
                    <div class="title-4 mb-20 font-700 text-uppercase">Дополнительные услуги</div>
                    <div v-for="service in item.services">
                        <div class="h5">{{service.name}} {{service.price}} RUB</div>
                    </div>
                </div>

                <div class="price-information mt-2 mt-sm-4">
                    <div class="d-lg-flex align-items-center">
                        <div class="price-box">Итого: <span class="font-700">{{item.common_price}} RUB</span></div>
                        <div class="dividing-line"></div>
                        <div class="price-box">Скидка: <span class="font-700">{{item.common_discount}} RUB</span></div>
                        <div class="dividing-line"></div>
                        <div class="price-box">Итого со скидкой: <span
                            class="font-700">{{item.final_price}} RUB</span></div>

                    </div>
                </div>

                <!--
                <div class="pt-3">
                    <a target="_blank" :href="'/generate-invoice/'+item.id+'/'+code" class="font-700">
                        <img src="/svg/document-pdf.svg" alt="" class="mr-1">Скачать смету
                    </a>
                </div>
                -->
            </div>

        </b-collapse>

        <div class="order-table__item">
            <div class="mobile_item"  @click="active = i"  v-b-toggle="'accordion-' + i">
                <div class="h5 d-inline-block d-lg-none text-uppercase mb-0">Заказ № 00{{i+1}}</div>
                <div class="d-none d-lg-inline-block">
                    <span v-if="i < 9 ">00{{i+1}}</span>
                    <span v-else-if="i > 8 && i < 99">0{{i+1}}</span>
                    <span v-else>{{i+1}}</span>
                </div>
                <div class="payment-box d-inline-block d-lg-none" v-if="item.payment_type === 'ЕРИП'">ЕРИП</div>
            </div>
            <div class="mobile_item"  @click="active = i"  v-b-toggle="'accordion-' + i">
                <span class="d-inline-block d-lg-none">Срок аренды</span>
                с {{getDateTime(item.booked_from)}}<br> по {{getDateTime(item.booked_until)}}
            </div>
            <div class="mobile_item"  @click="active = i"  v-b-toggle="'accordion-' + i">
                <span class="d-inline-block d-lg-none">Номер заказа</span>
                {{item.id}}
            </div>
            <div class="mobile_item"  @click="active = i"  v-b-toggle="'accordion-' + i">
                <span class="d-inline-block d-lg-none">Статус</span>
                {{item.status_id}}
            </div>
            <div @click="copyOrder(item)" class="item-link copy-btn"><img src="/svg/copy.svg" alt="" class="mr-1">Дублировать заказ</div>

            <div class="item-link copy-btn" v-if="item.order_id">
                <a target="_blank" :href="'/generate-invoice/'+item.order_id+'/'+code" class="font-700">
                    <img src="/svg/document-pdf.svg" alt="" class="mr-1">Скачать смету
                </a>
            </div>
            <div class="item-link copy-btn" v-else>
                <a target="_blank" :href="item.link_pdf" class="font-700">
                    <img src="/svg/document-pdf.svg" alt="" class="mr-1">Скачать смету
                </a>
            </div>
            <div class="item-link doc-btn" v-if="item.status_id == 'Принят'">
                <div>
<!--                    <button class="button btn-small btn-v2" v-b-modal="'modalFeedback_' + item.id" v-if="feedback_item">Посмотреть отзыв</button>-->
<!--                    <button class="button btn-small btn-v2" v-b-modal="'modalFeedback_' + item.id" v-if="!feedback_item">Оставить отзыв</button>-->
                    <button class="button btn-small btn-v2" @click="feedbackDialog = true" v-if="feedback_item">Посмотреть отзыв</button>
                    <button class="button btn-small btn-v2" @click="feedbackDialog = true" v-if="!feedback_item">Оставить отзыв</button>
                </div>
            </div>
            <div class="text-center" v-if="item.payment_type === 'ЕРИП'">
                <span class="payment-box d-none d-lg-inline-block" >ЕРИП</span>
            </div>
            <div class="select-image" @click="active = i"  v-b-toggle="'accordion-' + i">
                <span class="d-inline-block d-lg-none">Посмотреть детали</span>
                <img src="/svg/select.svg" alt="" class="d-lg-inline-block d-none">
                <img src="/svg/select-white.svg" alt="" class="d-inline-block d-lg-none mb-1">
            </div>
        </div>



        <!--  FEEDBACK MODAL -->
        <b-modal ref="modalFeedback" id="modal-feedback" v-model="feedbackDialog" title="" centered hide-footer hide-header>
            <div class="modalFeedback">
                <div class="close" @click="feedbackDialog = false"><img src="/svg/close.svg" alt=""></div>

                <div v-if="feedback_item">
                    <h3 class="font-700 mb-24">Ваш отзыв</h3>

                    <div class="mb-40">
                        <b-form-rating disabled="disabled" v-model="feedback_item.value"></b-form-rating>

                        <label for="feedback_text_show">Отзыв</label>
                        <textarea disabled="disabled" id="feedback_text_show" rows="10" v-model="feedback_item.text"></textarea>
                    </div>
                </div>

                <div v-if="!feedback_item">
                    <h3 class="font-700 mb-12">Оставить отзыв для заказа №{{item.id}}</h3>
                    <p class="mb-24">Поделитесь вашим мнением.</p>

                    <div class="mb-40">
                        <b-form-rating v-model="feedback.value"></b-form-rating>

                        <label for="feedback_text">Отзыв</label>
                        <textarea id="feedback_text" rows="10" v-model="feedback.text"></textarea>
                    </div>

                    <button class="button btn-small btn-v2" @click="addFeedback()">Сохранить отзыв</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import order from '../../../../services/order';
    import store from '../../../../services/data';

    export default {
        props: ['item', 'i', 'user', 'code'],

        data() {
            return {
                order: order,
                store: store,
                active: false,

                feedback: {
                    value: 5,
                    text: null,
                    order_id: this.item.id
                },

                feedback_item: null,
                feedbackDialog: false
            }
        },


        mounted() {
            if(this.item.feedback) this.feedback_item = this.item.feedback;
            console.log(this.item, 'item')
        },

        methods: {
            getDate(date) {
                return this.order.echoDate(date)
            },
            getDateTime(date) {
                return this.order.echoDateTime(date)
            },
            copyOrder(item) {
                let i = [];
                item.items.forEach(el => {
                    let new_el = {};
                    new_el.code = el.code;
                    new_el.count = el.count;
                    i.push(new_el);
                });
                this.store.setItemlocalStorage('chosen-products', i);
                this.store.getBasketCount();
                this.$router.push({ path: '/basket' });
            },

            addFeedback() {
                if(this.feedback.text) {
                    let url = '/api/save-review';
                    const options = {
                        headers: {Authorization: "Bearer " + localStorage.getItem('token')},
                    };
                    axios.post(url, this.feedback, options)
                        .then(response => {
                            if(response.status == 200) {
                                this.feedback_item = this.feedback;
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Сохранено.',
                                    html: `Ваш отзыв сохранен. <br> Спасибо, что поделились с нами Вашим мнением.`,
                                }).then(() => {
                                    this.feedbackDialog = false;
                                })
                            }
                        })

                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Вы не заполнили текст отзыва.',
                    });
                }
            }
        }
    }
</script>
